
import { useRef, useEffect } from 'react';

interface ProtectedLogoProps {
  src: string;
  alt: string;
  className?: string;
  watermarkText?: string;
}

export default function ProtectedLogo({ 
  src, 
  alt, 
  className = '',
  watermarkText = '© VyŽehlené'
}: ProtectedLogoProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Zabránění pravému kliknutí
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Zabránění drag & drop
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
      return false;
    };

    container.addEventListener('contextmenu', handleContextMenu);
    container.addEventListener('dragstart', handleDragStart);

    return () => {
      container.removeEventListener('contextmenu', handleContextMenu);
      container.removeEventListener('dragstart', handleDragStart);
    };
  }, []);

  return (
    <div 
      ref={containerRef}
      className={`relative select-none ${className}`}
      style={{ 
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
        WebkitTouchCallout: 'none'
      }}
    >
      {/* Hlavní logo */}
      <img 
        src={src}
        alt={alt}
        className="w-full h-full object-contain pointer-events-none"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
      />
      
      {/* Neviditelný watermark overlay - chrání před screenshoty */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'transparent',
          mixBlendMode: 'overlay'
        }}
      >
        {/* Opakující se watermark pattern */}
        <div 
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: `repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 20px,
              rgba(0,0,0,0.1) 20px,
              rgba(0,0,0,0.1) 40px
            )`
          }}
        />
      </div>

      {/* Skrytý copyright text pro SEO a právní ochranu */}
      <span className="sr-only">{watermarkText} - Chráněno autorským právem</span>
      
      {/* Transparentní ochranná vrstva */}
      <div 
        className="absolute inset-0 z-10"
        style={{ 
          background: 'transparent',
          cursor: 'default'
        }}
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
      />
    </div>
  );
}
